"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CountryIsoCode = (function () {
    function CountryIsoCode(code) {
        this.code = code;
        var pattern = "[A-Z]{2}";
        if (!new RegExp(pattern).test(code)) {
            throw new RangeError("Unable to construct CountryIsoCode: value must match " + pattern + " (Given: " + code + ")");
        }
        this.code = code;
    }
    CountryIsoCode.prototype.toJSON = function () {
        return this.code;
    };
    return CountryIsoCode;
}());
exports.CountryIsoCode = CountryIsoCode;
//# sourceMappingURL=CountryIsoCode.js.map